/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { BreadcrumbSkeleton, SkeletonText, IconSkeleton } from '@carbon/react';

// Icon Skeleton

var PageHeaderSkeleton = function PageHeaderSkeleton(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? true : _ref$title,
    actions = _ref.actions,
    icon = _ref.icon,
    light = _ref.light;
  var headerClassNames = classnames('cpc--page-header', 'cpc--page-header--skeleton', {
    'cpc--page-header--with-icon': icon,
    'cpc--page-header--light': light
  });
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__breadcrumb"
  }, breadcrumbs && /*#__PURE__*/React.createElement(BreadcrumbSkeleton, null)), /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__title-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__title"
  }, title && /*#__PURE__*/React.createElement(SkeletonText, {
    className: "cpc--page-header__title--skeleton",
    heading: true,
    width: "400px"
  })))), actions && /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__actions"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cds--btn cds--btn--field cds--skeleton"
  })));
  return /*#__PURE__*/React.createElement("div", {
    className: headerClassNames
  }, icon ? /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__main-container"
  }, content), /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__icon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cpc--page-header__icon"
  }, /*#__PURE__*/React.createElement(IconSkeleton, null)))) : content);
};
PageHeaderSkeleton.propTypes = {
  breadcrumbs: PropTypes.bool,
  title: PropTypes.bool,
  actions: PropTypes.bool,
  icon: PropTypes.bool,
  light: PropTypes.bool
};
var PageHeaderSkeleton$1 = PageHeaderSkeleton;

export { PageHeaderSkeleton$1 as default };
